import { InvisalignPage } from "~/components/invisalign/InvisalignPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/invisalign")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/invisalign"),
  component: InvisalignPage,
});
